export enum Role {
  USER = 'USER',
  ANNOTATOR = 'ANNOTATOR',
  DOCTOR = 'DOCTOR',
  ADMIN = 'ADMIN',
}
